export enum BonitaTypes {
	Movil = 'Móvil',
	Internet = 'Internet',
	Fixed = 'Fijo',
	TV = 'Televisión',
}
